import { Navigate } from "react-router-dom";
import { PAGE_TITLES } from "@miplatform/constants";
import { AccountDetails, Accounts } from "../../views";
import { Accounting } from "../../views/Accounting/Accounting";
import { AccountsReceivable } from "../../views/Accounting/AccountsReceivable/AccountsReceivable";
import { PaymentList } from "../../views/Accounting/AccountsReceivable/PaymentList/PaymentList";
import { PostPayments } from "../../views/Accounting/AccountsReceivable/PostPayment";
import { AuditLog } from "../../views/Accounting/AuditLog/AuditLog";
import { Reconcile } from "../../views/Accounting/Reconcile/Reconcile";
import { ACCOUNT_PAGE_TYPE } from "../../views/Accounts/accountsConstants";

export const accountingRoutes = [
  {
    path: "/accounting/invoices",
    name: "Accounting",
    exact: true,
    element: <Navigate to="all" replace />,
  },
  {
    path: "/accounting/audit-log",
    name: "Audit Log",
    element: <AuditLog />,
    handle: { title: PAGE_TITLES.AUDIT_LOG },
  },
  {
    path: "/accounting/accounts-receivable",
    name: "Accounts Receivable",
    exact: true,
    element: <Navigate to="open-payments" replace />,
    handle: { title: PAGE_TITLES.ACCOUNTS_RECEIVABLE },
  },
  {
    path: "/accounting/accounts-receivable/:tab",
    name: "Accounts Receivable",
    exact: true,
    element: <AccountsReceivable />,
    handle: { title: PAGE_TITLES.ACCOUNTS_RECEIVABLE },
  },
  {
    path: "/accounting/payments",
    name: "Payment List",
    exact: true,
    element: <PaymentList />,
    handle: { title: PAGE_TITLES.PAYMENTS },
  },
  {
    path: "/accounting/payments/:id",
    name: "Payments Details",
    element: <PostPayments />,
    handle: { title: PAGE_TITLES.PAYMENT },
  },
  {
    path: "/accounting/payments/new",
    name: "Post Payment",
    element: <PostPayments />,
    handle: { title: PAGE_TITLES.POST_PAYMENT },
  },
  {
    path: "/accounting/invoices/:id/pre-bill",
    name: "Pre-Bill",
    element: <Reconcile />,
  },
  {
    path: "/accounting/invoices/:id/invoice",
    name: "Invoice",
    element: <Reconcile />,
  },
  {
    path: "/accounting/invoices/:id/invoiced",
    name: "Invoiced",
    element: <Reconcile />,
  },
  {
    path: "/accounting/invoices/:tab",
    name: "Accounting",
    element: <Accounting />,
    handle: { title: PAGE_TITLES.ACCOUNTING },
  },
  {
    path: "/accounting/customers",
    name: "Customers",
    element: <Navigate to="builder" replace />,
  },
  {
    path: "/accounting/customers/:tab",
    name: "Customers",
    element: <Accounts type={ACCOUNT_PAGE_TYPE.CUSTOMER} />,
    handle: { title: PAGE_TITLES.CUSTOMERS },
  },
  {
    path: "/accounting/customers/:tab/:id",
    exact: true,
    name: "AccountsSummary",
    element: <Navigate to="summary" replace />,
    handle: { title: PAGE_TITLES.CUSTOMER },
  },
  {
    path: "/accounting/customers/:tab/:id/:accountTab",
    name: "AccountsSummary",
    element: <AccountDetails />,
    handle: { title: PAGE_TITLES.CUSTOMER },
  },
  {
    path: "/accounting/vendors",
    name: "Vendors",
    element: <Navigate to="subcontractor" replace />,
    handle: { title: PAGE_TITLES.VENDORS },
  },
  {
    path: "/accounting/vendors/:tab",
    name: "Vendors",
    element: <Accounts type={ACCOUNT_PAGE_TYPE.VENDOR} />,
    handle: { title: PAGE_TITLES.VENDORS },
  },
  {
    path: "/accounting/vendors/:tab/:id",
    exact: true,
    name: "AccountsSummary",
    element: <Navigate to="summary" replace />,
    handle: { title: PAGE_TITLES.VENDOR },
  },
  {
    path: "/accounting/vendors/:tab/:id/:accountTab",
    name: "AccountsSummary",
    element: <AccountDetails />,
    handle: { title: PAGE_TITLES.VENDOR },
  },
];
